import hoistNonReactStatics from 'hoist-non-react-statics'
import * as React from 'react'
// note that this HOC can be fired multiple times if parent component rerenders
export function HOCFactoryFactory(
  connect: (...args: Array<any>) => any,
  dataLoader: (props: any) => Promise<any>,
): (WrappedComponent: React.ComponentType<any>) => any {
  return function HOCFactory(WrappedComponent: React.ComponentType<any>) {
    const Component: React.ComponentType<any> = class HOC extends React.Component<
      any,
      {
        error: Error | null | undefined
        loading: boolean
        data: any | null | undefined
      }
    > {
      state = {
        error: null,
        loading: false,
        data: null,
      }

      async loadData(props: unknown) {
        if (this.state.loading) return
        this.setState({
          error: null,
          loading: true,
          data: null,
        })

        try {
          const data = await dataLoader(props)
          this.setState({
            error: null,
            loading: false,
            data,
          })
        } catch (error) {
          this.setState({
            error,
            loading: false,
            data: null,
          })
        }
      }

      componentDidMount() {
        this.loadData(this.props)
      }

      async UNSAFE_componentWillReceiveProps(nextProps: unknown) {
        this.loadData(nextProps)
      }

      render() {
        const { error, loading, data } = this.state
        const params = { ...data, error, loading }
        return <WrappedComponent {...this.props} {...params} />
      }
    }
    Component.displayName = `WithData(${getDisplayName(WrappedComponent)})`
    hoistNonReactStatics(Component, WrappedComponent)
    return connect()(Component)
  }
}

const getDisplayName = WrappedComponent => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}

export default HOCFactoryFactory
